import debug from "src/modules/debug-logger";
import { Type } from "src/modules/media-upload-protobuf";

const Buffer = window.require("buffer")?.Buffer;

const DATA_BUFFER_LENGTH = 500;

export default async function uploadData({ ws, fileHandle, media }) {
  let bytesRead = 0;
  let fileSize;
  let numberOfFullBuffers;
  let lastBufferSize;
  let currentBufferIndex = 0;

  const fsStat = await fileHandle.stat();
  fileSize = fsStat.size;
  numberOfFullBuffers = Math.floor(fileSize / DATA_BUFFER_LENGTH);
  lastBufferSize = fileSize - numberOfFullBuffers * DATA_BUFFER_LENGTH;
  debug.activityLog("File size", fileSize);

  function sendDataMessage(data) {
    const message = Type.Message.create({
      dataMessage: Type.DataMessage.create({ data })
    });
    ws.send(Type.Message.encode(message).finish());
  }

  for (
    currentBufferIndex;
    currentBufferIndex < numberOfFullBuffers;
    currentBufferIndex++
  ) {
    const bufferToSend = Buffer.alloc(DATA_BUFFER_LENGTH);
    await fileHandle.read(
      bufferToSend,
      0,
      DATA_BUFFER_LENGTH,
      currentBufferIndex * DATA_BUFFER_LENGTH
    );
    sendDataMessage(bufferToSend);
  }
  if (lastBufferSize > 0) {
    const bufferToSend = Buffer.alloc(lastBufferSize);
    await fileHandle.read(
      bufferToSend,
      0,
      lastBufferSize,
      currentBufferIndex * DATA_BUFFER_LENGTH
    );
    sendDataMessage(bufferToSend);
  }

  debug.activityLog(
    `finished reading file ${media.fileName}, bytesRead ${bytesRead}`
  );
}
